import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import { useIsMaster } from '@btime/react-session'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { cleanWhenEnabledFilterIsSet } from '../../../_helpers/filterByEnabled'

const Context = React.createContext()
const { Provider } = Context
export const useUsersState = () => React.useContext(Context) || {}
export const useUsers = () => useUsersState()?.users || []

const QUERY = gql`
  query Users($page: Int, $search: String, $sort: UserSort, $filter: UserFilter) {
    users(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      email
      contract {
        id
        group {
          id
          name
        }
        groups {
          id
          name
        }
        profile {
          id
          name
        }
        enabled
        deleted
      }
      mobileDetails
      isFakeEmail
    }
  }
`

const UsersLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type },
      filter: {
        ...cleanWhenEnabledFilterIsSet({
          ...filter,
          hideMasters: !useIsMaster(),
          ignoreSegments: true,
          includeDisabled: true
        })
      }
    },
    client: accountsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default UsersLoader
